import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import './Article.css';
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast } from "react-toastify";

const backEndURL = process.env.REACT_APP_BACKEND_URL;

const Article = () => {
	const { id } = useParams();
	const [article, setArticle] = useState(null);
	const navigate = useNavigate();


	useEffect(() => {
		const fetchBlog = async () => {
			try {
				const response = await axios.get(`${backEndURL}/blog/${id}`);
				setArticle(response.data);
			} catch (err) {
				toast.error("Failed to load the blog. Please try again later.", {
					position: "top-center",
					theme: "dark",
				});
			}
		};

		fetchBlog();
	}, [id]);

	if (!article) {
		return <div className="loading">Loading...</div>;
	}

	return (
		<div className="articleContainer">
			<button
				onClick={() => navigate(-1)}
				className="back-button"
			>
				<IoMdArrowRoundBack />
			</button>
			{article.image && (
				<img
					src={article.image}
					alt="Article"
					className="articleImage"
				/>
			)}

			{/* Render dynamic content */}
			{article.data.map((item, index) => {
				switch (item.type) {
					case "title":
						return <h1 key={index} className="articleTitle">{item.value}</h1>;
					case "paragraph":
						return <p key={index} className="articleParagraph">{item.value}</p>;
					default:
						return null;
				}
			})}

			{/* Meta Information */}
			<hr className="articleMetaLine" />
			<div className="articleMeta">
				<span className="articleDate">{new Date(article.createdAt).toLocaleDateString()}</span>
				<div className="articleCategories">
					{article.category.map((cat, index) => (
						<span key={index} className="articleCategory">{cat}</span>
					))}
				</div>
			</div>
		</div>
	);
};

export default Article;
